import { useLazyGetFileUrlQuery } from "store/services/utility";

export const useFileViewer = () => {
  const [getFileUrl, { isLoading: getFileLoading }] = useLazyGetFileUrlQuery();

  const handleViewPdf = async (name) => {
    try {
      const result = await getFileUrl(name);
      if (result?.error) return;

      const url = result?.data;
      if (url) window.open(url, '_blank');
    } catch (err) {
      console.error("Error viewing PDF", err);
    }
  };

  return { handleViewPdf, getFileLoading };
};